"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERPRegionRequestDtoSortByPrefList = void 0;
exports.SERPRegionRequestDtoSortByPrefList = [
    'recommendedAsc',
    'priceAsc',
    'priceDesc',
    'ratingAsc',
];
